import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";

// The class is doubled so these rules outrank a child's own margins, which
// otherwise tie on specificity and win or lose on style injection order. The
// gaps are set per data-gap rather than through a custom property: the margin
// is computed on the child, so a nested Stack would read its own gap instead.
const Root = styled.div`
  && > * {
    margin-top: 0;
    margin-bottom: 0;
  }

  && > * + * {
    margin-top: var(--juno-space-4);
  }

  &&[data-gap="none"] > * + * {
    margin-top: 0;
  }

  &&[data-gap="xxs"] > * + * {
    margin-top: var(--juno-space-1);
  }

  &&[data-gap="xs"] > * + * {
    margin-top: var(--juno-space-2);
  }

  &&[data-gap="sm"] > * + * {
    margin-top: var(--juno-space-3);
  }

  &&[data-gap="lg"] > * + * {
    margin-top: var(--juno-space-6);
  }

  &&[data-gap="xl"] > * + * {
    margin-top: var(--juno-space-8);
  }
`;

const Stack = ({ children, gap, ...props }) => (
  <Root data-gap={gap === "md" ? undefined : gap} {...props}>
    {children}
  </Root>
);

Stack.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  gap: PropTypes.oneOf(["none", "xxs", "xs", "sm", "md", "lg", "xl"]),
  as: PropTypes.elementType,
};

export default Stack;
